/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface HolderBonus
 */
export interface HolderBonus {
  /**
   *
   * @type {string}
   * @memberof HolderBonus
   */
  farmAddress?: string
  /**
   *
   * @type {number}
   * @memberof HolderBonus
   */
  currentBonus?: number
  /**
   *
   * @type {number}
   * @memberof HolderBonus
   */
  nextBonus?: number
  /**
   *
   * @type {Array<number>}
   * @memberof HolderBonus
   */
  holderBonusProgress?: Array<number>
  /**
   *
   * @type {number}
   * @memberof HolderBonus
   */
  currentRewardInNmx?: number
  /**
   *
   * @type {number}
   * @memberof HolderBonus
   */
  poolShare?: number
}

export function HolderBonusFromJSON(json: any): HolderBonus {
  return HolderBonusFromJSONTyped(json, false)
}

export function HolderBonusFromJSONTyped(json: any, ignoreDiscriminator: boolean): HolderBonus {
  if (json === undefined || json === null) {
    return json
  }
  return {
    farmAddress: !exists(json, 'farmAddress') ? undefined : json['farmAddress'],
    currentBonus: !exists(json, 'currentBonus') ? undefined : json['currentBonus'],
    nextBonus: !exists(json, 'nextBonus') ? undefined : json['nextBonus'],
    holderBonusProgress: !exists(json, 'holderBonusProgress') ? undefined : json['holderBonusProgress'],
    currentRewardInNmx: !exists(json, 'currentRewardInNmx') ? undefined : json['currentRewardInNmx'],
    poolShare: !exists(json, 'poolShare') ? undefined : json['poolShare'],
  }
}

export function HolderBonusToJSON(value?: HolderBonus | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    farmAddress: value.farmAddress,
    currentBonus: value.currentBonus,
    nextBonus: value.nextBonus,
    holderBonusProgress: value.holderBonusProgress,
    currentRewardInNmx: value.currentRewardInNmx,
    poolShare: value.poolShare,
  }
}
